<template>
    <div class="main" v-if="imgurl" >
		<loading v-if="loading"></loading>
        <div class="bananer posn"> 
            <img id="bana3" v-if="isBana" :src="'https://img.lanniuzai.com/'+bgsrc"/>
            <div v-else>
                <video v-if="isShowvideo" id="v1" style="width:100%; height:100%; object-fit:fill" class="thevideo lazy" preload="auto" poster autoplay loop muted playsinline>
                    <source class="thevideos" :src="video" type="video/mp4">
                </video>
            </div>
            <div class="serch">
                <span class="logo fleft"><img :src="$t('lan.logo')" :class="$lang==1 ? 'imgEn' : 'imgCn' "/></span>
                <p class="navLog" v-if="userInfo" @click="topNav()">
					<img :src="'https://img.lanniuzai.com/'+userInfo.userIcon">
				</p>
                <span class="navBtn show cur" v-else @click="topNav()"></span>
                <span class="serBtn show" v-if="isSerch"></span>
                <div class="sercon"><!-- onkeyup="onseek(\'#serchcon\',\'0\')" -->
                    <input class="input482 f14" type="text" v-model="keyword"  value="" name="serchkey" :placeholder="$t('lan.serTit')"/>
                    <a id="btn_Index" class="btnblue_95 cur" @click="getSerch" target="_blank"></a>
                </div>
                <!-- <p class="serBtn animate bounceIn" v-if="isCurrtImg" @click="getVideo" >
                <span class="btn show"></span>{{$t('lan.imgTit')}} 
                
                </p>
                <p class="serBtn animate bounceIn" v-if="isCurrtVideo" @click="getVideo"><span class="btn show"></span>{{$t('lan.motion')}}</p> -->
                <div class="toggle-button-cover" :class="$lang==1 ? 'en' : 'cn' ">
                    <div class="button r" :class="isCurrtype ? 'active' : ''" @click="getVideo">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="adDiv">
            <span class="top show fleft" :class="$lang==1 ? 'en' : '' " v-html="$t('lan.adTop')"></span>
            <p class="js show fleft" v-if="$lang==0" :class="$lang==1 ? 'en' : '' " v-html="$t('lan.purworld')"></p>
            <p class="title fleft">
                <span class="show fleft posn" @click="getImg" >
                    <A :class="isimgType==1 ? 'click' : 'text-hover text-underline'" >
                    {{$t('lan.editorSelects')}}</A>
                </span>
                <span class="show fleft posn" @click="getImg" ><A :class="isimgType!=1 ? 'click' : 'text-hover text-underline'" >{{$t('lan.newline')}}</a></span>
            </p>
        </div>
        <div class="" v-if="isimgType==1">
            <ul class="list" >
                <li v-for="(item,key) in list" :key="key" @click="toserch(item.productSubjectId)"><img :src="'https://img.lanniuzai.com/'+item.subjectCover"/></li>
            </ul>
        </div>
        <section  v-else>
            <div :id="img.productId" v-for="(img,i) in imglist" :key="i" class="demoH " :data-lt="img.saleFormat" :style="'width:'+img.imgw+'px;flex-grow:'+img.imgw+';'">
                <i :style="'padding-bottom:'+img.rate+'%'"></i>
                <a @click="todeta(img.productNumber)"  style="display:block;">
                    <img  v-lazy="'https://img.lanniuzai.com/'+img.pm1MediaUrl" :id="'tn'+img.productId" :width="img.imgw" :data-w="img.pm1Width" :data-h="img.pm1Height"/>
                </a>
            </div>
        </section>
        <div class="foot">
            <span class="f32">{{$t('lan.aboutjean')}}</span>
            <span class="f20 con" v-html="$t('lan.companyJs')"></span>
            <ul class="codelist">
            <li v-for="(item,i) in codelist" :key="i" @click="getCode(i)"><img :src="currentIndex==i ? item.checked : item.img"/></li>
            </ul>
            <div class="code" v-if="isCode">
				<a href="https://mp.weixin.qq.com/s/E6Ge2QRumtf23ZCWJ_cN6g">
					<img v-if="codeType==0" src="../assets/wap/icon_code.png"/>
				</a>
            <img v-if="codeType==1" src="../assets/wap/icon_codeqq.jpg"/>
            <a href="https://www.weibo.com/lnzyx?is_hot=1"><img v-if="codeType==2" src="../assets/wap/icon_codewb.jpg"/></a>
            </div>
            <span class="f22 kf">{{$t('lan.salekf')}}<br/>400-6968995</span>
            <span class="kf f22">{{$t('lan.wmail')}}<br/>info@lanniuzai.com</span>
            <span class="bq">
            <a href="https://www.lanniuzai.com/statement.html">{{$t('lan.copynote')}}</a>
            <a class="m35L m35R">|</a>
            <a @click="toMessage">{{$t('lan.system')}}</a></span>
            <p class="sm" v-html="$t('lan.wapend')"></p>
            <span class="bbtn 18"><a href="https://www.lanniuzai.com/">{{$t('lan.desktop')}}</a></span>
        </div>
		<navList v-if="isLogin" @closeBox = "closed"></navList>
        <message v-if="isLeaving" @closeBox = "closed"></message> 
    </div>
</template>

<script>
import navList from './nav.vue'
import Vue from 'vue';
import { Lazyload } from 'vant';
import message from './message.vue';
Vue.use(Lazyload);
import loading from '../public/loading.vue';
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
	lazyComponent: true
});
import { mapGetters,mapMutations } from 'vuex';
export default {
    name: 'app',
    components: {
        navList,
        message,
		loading
    },
    inject:['reload'],
    data(){
        return {
			loading: true,
            list:[],
            isLogin:false,
            tagcon:'',
            number:'',
            tagxk:'1,2',
            tagsc:'RM,RF,RM%20Exclusive',
            isSerch:false,
            keyword:'',
            video:'',
            gt:'',
            gtid:'',
            tagex_q:'',
            pp:'',
            serid:'',
            brandId:'',
            holderId:'',
            tagzts:'',
            tagage:'',
            tagcy:'',
            tagrs:'',
            taggt:'',
            tagB:'',
            tagH:'',
            way:'',
            usericon:'',
            userid:'',
            codelist:[
                {id: 1, img: require('../assets/wap/icon_wx.png') , checked: require('../assets/wap/icon_wxC.png') },
                {id: 2, img: require('../assets/wap/icon_qq.png') , checked: require('../assets/wap/icon_qqC.png')},
                {id: 3, img: require('../assets/wap/icon_wb.png') , checked: require('../assets/wap/icon_wbC.png')},
            ],
            currentIndex:-1,
            isCode:false,
            bgsrc:'',
            isimgType:1,
            isType:false,
            codeType:0,
            isCurrtype:false,
            isBana:true,
            isShowvideo:false,
            isShow:false,
            checked:false,
            imglist:[],
            isLeaving:false,
            islog:false,
			imgurl:'',
        }
    },
    created() {

    },
    mounted(){
		console.log(this.isRunLogin)
        if(this.$lang == 1){
            document.title="Blue Jean Images China";
        }
		this.imgurl = this.$imgurl;
        this.getbana();
        this.getZT();
    },
    destroyed(){
    
    },
    methods:{
		...mapMutations([
		    'setSerchCon',
		]),
        //获取大图
        getbana(){
			let _this = this;
            let data = {
                position:'mobile',
            };
            //debugger
            _this.$api.bannerImg(data).then((res)=>{
				if(res.result == 'success'){
					_this.bgsrc = res.list[0].sections[0].mediaUrl; 
					_this.loading = false;
				}
            }).catch((err)=>{
                console.log(err) 
            }) 
        },
        //视频
        async getbaVideo(){
			let _this = this;
			let data = {
				position : 'mobile'
			}
            await _this.$api.bannerVideo(data).then((res)=>{
                this.video='https://img.lanniuzai.com/'+res.list[0].mediaUrl; 
                this.isShowvideo=true;
            }).catch((err)=>{
                console.log(err) 
            }) 
        },
        //专题
        async getZT(){
			let _this = this;
			let data = {
			    position:'mobile',
			};
            var lan = this.$lang==1 ?　'en' : 'cn';
            await _this.$api.getProduct('/product/subject'+'/3/'+lan+'/1/100').then((res)=>{
				if(res.result == 'success'){
					_this.list = res.list;
				}
            }).catch((err)=>{
                console.log(err) 
            })
        },
        //最新上线
        async getNewline(){
            //return;
			let _this = this;
			let data = {
				keywords : '',
				attributeSetId: '1,2',
				saleFormat : 'RM,RF,RM Exclusive',
				pageSize: 50,
				latestOnline: 1,
				currentPage: 0
			}
            await _this.$api.getSearch(data).then((res)=>{
				var list= res.pages.content;
				list.forEach((item,i) => {
				    var imgw=Math.ceil(item.pm1Width*120/item.pm1Height);
				    var rate=item.pm1Height/item.pm1Width*100;
				    _this.$set(item,'imgw',imgw);
				    _this.$set(item,'rate',rate);
				    
				});
				_this.imglist = list;
            }).catch((err)=>{
                console.log(err) 
            })
        },
        //打开导航
        topNav(){
            this.isLogin=true;
        },
        toMessage(){
            this.isLeaving=true;
        },
        getCode(id){
            //var id = event.target.dataset.index;
            this.currentIndex = (this.currentIndex==id) ? -1 : id;
            this.codeType=id;
            if(this.currentIndex==id){
                this.isCode=true;
            }else{
                this.isCode=false;
            }
        },
        //关闭
        closed(){
            this.isLogin=false;
            this.isLeaving=false;
        },
        //搜索 图片视频切换
        getVideo(){
            this.isCurrtype=!this.isCurrtype;
            if(this.isCurrtype){
                this.isBana=false;
                this.getbaVideo();
            }else{
                this.isBana=true;
                this.getbana();
            }
        },
        //专题 和 最新上线 切换
        getImg(){
            this.isType=!this.isType;
            if(this.isType){
                this.isimgType=2;
                this.getNewline();
            }else{
                this.isimgType=1;
                this.getZT();
            }
        },
        getshow(){
            this.isShow=true;
        },
        //到搜索页
        getSerch(){
            var keyword = decodeURIComponent(this.keyword);
            if (this.isBana) {
				this.setSerchCon({
					type : 1,
					keyword: keyword
				})
               
            }else{
                this.setSerchCon({
                	type : 2,
                	keyword: keyword
                })
            }
			this.$router.push({
				path:'/search',
			})
        },
        //专题
        toserch(id){
			this.$router.push({ 
				path:'/special',
				query: { 
					id: id ,
				},
			})
        },
        // 详情页
        todeta(num){
			this.$router.push({ 
				path:'/detailpage', 
				query: { 
					num: num ,
				},
			})
        }
    }
}
</script>
<style lang="scss" scoped>
    .main{
      width:750px;
      margin:0 auto;
    }
    body{margin:0; padding:0; background:#fff;}
    .bananer{
        width:100%;
        height:1280px;
        img{
            width:750px;
            height:1280px;
            position:absolute;
            left:0;
            top:0;
        }
        .video{
            width:750px;
            height:1280px;
        }
        .serch{
            position: absolute; 
            overflow:hidden; 
            width:750px;
            height:100%;
            left:0; 
            top:0;
            z-index:10;
            .serBtn{
            background:rgba(51,51,51,.9); 
            width:110px;
            height:78px;
            position:absolute; 
            top:836px; 
            left:50%;
            margin-left:-100px;
            color:#fff;
            font-size:36px;
            border-radius:78px;
            line-height:78px;
            padding-left:90px;
            .btn{
                width:32px;
                height:32px;
                background:#059fbf;
                border-radius:50%;
                position:absolute;
                left:23px;
                top:23px;
            }

        }     
        .sercon{
            position:absolute; 
            width:704px;
            height:80px;
            background:rgba(77,77,77,.5);
            left:28px; 
            top:696px; 
            z-index:20; 
            color:#fff;
        }
        .dropBtn{
            width:65px; 
            height:35px; 
            background:url(https://static.lanniuzai.com/img/icon_btn.png) no-repeat -236px -479px; 
            position:absolute; 
            bottom:10px; 
            left:50%; 
            margin-left:-33px;
        }
        .input482{
          width:542px; 
          height:60px; 
          font-size:14px; 
          padding-right:22px; 
          color:#fff; 
          line-height:60px; 
          position:absolute; 
          left:30px; 
          top:10px; 
          z-index:10;
          font-size:30px;
          background:none;
		  border: none;
        }
        .input482::-webkit-input-placeholder {
            color:#fff !important;
        }
        .input482:-moz-placeholder {
            color:#fff !important;
        }
        .input482:-ms-input-placeholder {
            color: #fff !important;
        }
        .btnblue_95{
          width:80px; 
          height:80px; 
          position:absolute; 
          right:0; 
          top:0px; 
          background:url(../assets/wap/nifierN.png) no-repeat 10px center #0f9ee6; 
          background-size:60px 60px;
        }
        .btnblue_95:hover{
          background:url(../assets/wap/nifierN.png) no-repeat 10px center hsl(200, 87%, 43%); 
          background-size:60px 60px;
        }
      }
      .logo{
        position:absolute; 
        left:0; 
        top:0; 
        z-index:20; 
        width:425px;
        height:81px;
        .imgEn{
          width:315px;
          height:68px;
          margin:30px 30px;
        }
        .imgCn{
          width:405px;
          height:68px;
          margin:30px 30px;
        }
      }
      .navBtn{
        width:50px; 
        height:38px; 
        background:url(../assets/wap/icon_nav2APP.png) no-repeat; 
        background-size:50px 38px;
        position:absolute; 
        right:36px; 
        top:36px; 
        z-index:30;
      }
        .navLog{
            background:url(../assets/wap/pic_btn.png) no-repeat 0 center; 
            background-size:20px 17px;
            padding-left:35px;
            width:100px;
            height:100px;
            position:absolute; 
            right:36px; 
            top:28px; 
            z-index:30;
            img{
                width:100px;
                height:100px;
                border-radius:50%;
                position: absolute;
                left:35px;
                top:0;
            }

        }
      .nav_R{
        z-index:22; 
        line-height:40px;
      }
    }
    .adDiv{
        width:100%;
        height:350px;
        background:#f2f2f2;
        text-align: center;
		overflow:hidden;
        .top{
          font-size:46px;
          line-height:75px;
          margin:40px 85px 0;
          width:580px;
          letter-spacing: 2px;
        }
        .top.en{
          letter-spacing:0px;
          font-size:32px;
          width:710px;
          margin:40px 20px 0;
        }
        .js{
          font-size:20px;
		  width:100%;
          line-height:45px;
          letter-spacing: 2px;
          height:45px;
		  display: flex;
		  justify-content: center;
        }
        .js.en{
          width:710px;
          letter-spacing: 0px;
          font-size:18px;
          padding:0 20px;
        }
        .title{
          margin-top:75px;
          width:560px;
          padding:0 95px;
          height:85px;
          line-height:85px;
          display:flex;
          span{
            width:auto;
            text-align: center;
            font-size:30px;
            flex:1;
            .click{
              border-top:solid 5px #01b0ff;
              color:#00a8ff;
              
            }
            a{
              width:auto;
              line-height:85px;
              height:85px;
              display:inline-block;
            }
            
            
          }
        
        }
    }
    .list{
      width:750px;
      height:auto;
      zoom: 1;
      overflow: auto;
      li{
        width:250px;
        height:250px;
        float: left;
        overflow: hidden;
        img{
          width:250px;
          height:250px;
        }
      }
    }

    .foot{
      background:#2e2e2e;
      width:100%;
      height:auto;
      overflow: auto;
      zoom: 1;
      color:#fff;
      .top{
        width:100%;
        text-align: center;
        color:#a6a6a6;
        font-size:30px;
        margin-top:40px;
        line-height:80px;
        letter-spacing: 3px;
      }
      span{
        width:100%;
        display: block;
        text-align:center;
      }
      a{
        color:#fff;
      }
      .codelist{
        width:610;
        display:flex;
        padding:75px 70px 50px 70px;
        li{
          flex:1;
          text-align: center;
          height:65px;
          width:auto;
          img{
            width:73px;
            height:61px;
          }
        }
      }
      .code{
        height:400px;
        background:#262626;
        text-align: center;
        width:100%;
        img{
          height:257px;
          width:261px;
          margin-top:71px;
        }
      }
      .sm{
        color:#999999;
        font-size:16px;
        line-height:32px;
        text-align: center;
      }
      .bbtn{
        line-height:80px;
        text-align: center;
        width:100%;
      }
      .con{
        line-height:32px;
        font-size:20px;
      }
      .kf{
        line-height:40px;
        margin-bottom:20px;
      }
      .f32{
        line-height:110px;
        font-size:32px;
        margin-top:60px;
      }
      .yx{
        line-height:140px;
        font-size:20px;
      }
      .bq{
        line-height:100px;
        font-size:20px;
      }
    }
    .text-underline:before {
        content:"";
        position:absolute;
        z-index:-1;
        transition-property:width,background-color;
        width:0;
        height:5px;
        top:0;
        left:0;
        margin:0 auto
    }
    .text-underline:hover:before {
        outline:0;
        transition-property:width,background-color;
        width:140px;
    }
    .text-hover {
        display:inline;
        transition-timing-function:ease-in-out;
        transition-duration:.7s;
        transition-delay:0s;
        transition-property:color;
        white-space:nowrap;
        overflow:hidden;
        position:relative;
        z-index:2;
        text-decoration:none;
        box-sizing:border-box;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        -webkit-touch-callout:none;
        -webkit-tap-highlight-color:rgba(0,0,0,0)
    }
    .text-hover:after,.text-hover:before {
        transition-duration:.7s;
        transition-timing-function:ease-in-out;
        transition-delay:0s;
        background-color:#00a8ff;
    }
    .text-hover:hover {
        outline:0;
        cursor:pointer;
        color:#00a8ff;
        transition:color .7s ease-in-out
    }
    .text-hover:hover:after,.text-hover:hover:before {
        background-color:#00a8ff;
    }
     
    .toggle-button-cover{
        width: 200px;
        box-sizing: border-box;
        //background:rgba(51,51,51,.9); 
        height:78px;
        position:absolute; 
        top:836px; 
        left:50%;
        margin-left:-100px;
        color:#fff;
        font-size:36px;
        border-radius:78px;
        line-height:78px;
        .knobs, .layer{
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
        .button{
            position: relative;
            top: 0;
            width:100%;
            height: 100%;
            left:0;
            overflow: hidden;
        }
        .button.r, .button.r .layer{
            border-radius: 78px;
        }

        .button.b2{
            border-radius: 2px;
        }

        .checkbox{
            position: relative;
            width: 100%;
            height: 100%;
            padding: 0;
            margin: 0;
            opacity: 0;
            cursor: pointer;
            z-index: 3;
        }

        .knobs{
            z-index: 2;
        }

        .layer{
            width: 100%;
            background-color: rgba(77,77,77,.5);
            transition: 0.3s ease all;
            z-index: 1;
        }

        /* Button 1 */
        .knobs:before{
          content: '';
            color: #fff;
            font-size: 10px;
            font-weight: bold;
            text-align: center;
            line-height: 1;
            width:32px;
            height:32px;
            background:#0f9ee6;
            border-radius:50%;
            position:absolute;
            left:23px;
            top:23px;
            transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
        }
        .layer:before{
          content: '图片';
          position:absolute;
          left:100px;
          top:0;
          line-height:78px;
          transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
        }
        .active .knobs:before{
            content: '';
            left: 145px;
            background-color: #0f9ee6;
        }
        .active .layer{
            background-color: rgba(77,77,77,.5);
            // content: '视屏';
            // left: 45px;
        }
        .active .layer:before{
        // background-color: #fcebeb;
            content: '视频';
            left: 45px;
        }
        .knobs,.knobs:before,.layer{
            transition: 0.3s ease all;
        }
    }
    .en{
      .layer:before{
          content: 'Images';
          left:62px;
      }
      .active .layer:before{
          content: 'Motion';
          left: 20px;
      }
      .active .knobs:before{
          content: '';
          left: 155px;
          background-color: #0f9ee6;
      }
      .knobs:before{
        left:18px;
      }

    }
    section{
      display: flex;
      flex-wrap: wrap;
      width:100%;
      height:auto;
      zoom: 1;
      //overflow: auto;
    }
    section::after {
      content: '';
      flex-grow: 999999999;
    }
    .demoH {
        flex-grow: 1; //让图片始终填满一整行
        height:auto;
        float: left;
        //height: 150px;
        //margin:1px;
        position: relative;
        i{
              display: block;
        }
        img{
          // width: auto;
          // height: 150px;
          // object-fit: cover; //图片适应容器并且不裁切
          // min-width: 100%;
          position: absolute;
          top: 0;
          width: 100%;
          vertical-align: middle;
        }
    }



</style>
